// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'collab.public',
    path: 'my/investApplication',
    name: 'UserInvestList',
    component: () => import('./PgUserInvestList'),
    meta: {
      title: '投資項目申請',
      authenticated: true
    }
  }
]
